var isRegExp = require('../internals/is-regexp');

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/not-a-regexp.js
// module id = 132
// module chunks = 0 1 2 3 4 6 7 8 9 10 11 16 18 20 26 30 40 51